<template>
  <div class="page-wrapper has-tabbar">
      <div class="my-page">
          <div class="user-profile-card">
              <div class="profile-header">
                  <div class="user-avatar">
                      <div class="avatar-circle"><span class="avatar-text">{{ userInfo.username ? userInfo.username.charAt(0).toUpperCase() : '' }}</span></div>
                  </div>
                  <div class="profile-info">
                      <div class="profile-name">{{ userInfo.username }}</div>
                      <div class="profile-level"><span class="level-badge">{{ userInfo.vip_level }}</span></div>
                      <div class="invite-section"><span class="invite-label">{{ t('my.inviteCode') }}: {{ inviteCode }}</span>
                          <div class="copy-btn" @click="copyInviteCode"><span class="copy-text">{{ t('my.copy') }}</span></div>
                      </div>
                  </div>
                  <div class="online-status-container">
                      <div class="online-status">
                          <div class="status-indicator online">
                              <div class="status-dot"></div><span class="status-text">{{ t('my.online') }}</span></div>
                          </div>
                      </div>
              </div>
          </div>


          <div class="balance-overview">
              <div class="balance-header"><span class="balance-title">{{ t('my.accountBalance') }}</span>
                  <div class="balance-icon">💰</div>
              </div>
              <div class="balance-cards">
                  <div class="balance-card main-balance">
                      <div class="card-content">
                          <div class="balance-label">{{ t('my.balance') }}</div>
                          <div class="balance-amount"><span class="currency">{{ appConfig.currency.symbol }}</span><span class="amount">{{ displayMainBalance }}</span></div>
                          <div class="balance-trend"><span class="trend-icon">📈</span><span class="trend-text">{{ t('my.accountBalanceTrend') }}</span></div>
                      </div>
                      <div class="card-bg-effect"></div>
                  </div>
                  <div class="balance-card receivable-balance">
                      <div class="flip-container" :class="{ 'is-flipped': isFlipped }">
                          <div class="flip-front">
                              <div class="card-content">
                                  <div class="balance-label">{{ t('my.todayCommission') }}</div>
                                  <div class="balance-amount"><span class="currency">{{ appConfig.currency.symbol }}</span><span class="amount">{{ displayTodayCommission }}</span></div>
                                  <div class="balance-trend"><span class="trend-icon">📅</span><span class="trend-text">{{ t('my.today') }}</span></div>
                              </div>
                              <div class="card-bg-effect"></div>
                          </div>
                          <div class="flip-back">
                              <div class="card-content">
                                  <div class="balance-label">{{ t('my.totalCommission') }}</div>
                                  <div class="balance-amount"><span class="currency">{{ appConfig.currency.symbol }}</span><span class="amount">{{ displayTotalCommission }}</span></div>
                                  <div class="balance-trend"><span class="trend-icon">💰</span><span class="trend-text">{{ t('my.total') }}</span></div>
                              </div>
                              <div class="card-bg-effect"></div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- <div class="stats-row">
                  <div class="stat-item">
                      <div class="stat-number">{{ userInfo.day_order_count }}
                      </div>
                      <div class="stat-label">{{ t('my.todayOrders') }}</div>
                  </div>
                  <div class="stat-divider"></div>
                  <div class="stat-item">
                      <div class="stat-number">{{ userInfo.order_num }}</div>
                      <div class="stat-label">{{ t('my.orderCount') }}</div>
                  </div>
              </div> -->
          </div>


          <div class="quick-actions">
              <div class="actions-header"><span class="actions-title">{{ t('my.balance') }}</span>
                  <div class="actions-icon">⚡</div>
              </div>
              <div class="actions-grid">
                  <div class="action-item" @click="navigateTo('/recharge')">
                      <div class="action-icon">
                          <el-icon><Wallet /></el-icon>
                      </div>
                      <div class="action-name">{{ t('my.recharge') }}</div>
                      <div class="action-arrow">→</div>
                  </div>
                  <div class="action-item" @click="navigateTo('/withdraw')">
                      <div class="action-icon">
                          <el-icon><Money /></el-icon>
                      </div>
                      <div class="action-name">{{ t('my.withdraw') }}</div>
                      <div class="action-arrow">→</div>
                  </div>
                  <div class="action-item" @click="navigateTo('/recharge-record')">
                      <div class="action-icon">
                          <el-icon><Document /></el-icon>
                      </div>
                      <div class="action-name">{{ t('my.rechargeRecord') }}</div>
                      <div class="action-arrow">→</div>
                  </div>
                  <div class="action-item" @click="navigateTo('/withdraw-record')">
                      <div class="action-icon">
                          <el-icon><List /></el-icon>
                      </div>
                      <div class="action-name">{{ t('my.withdrawRecord') }}</div>
                      <div class="action-arrow">→</div>
                  </div>
                  <div class="action-item" @click="navigateTo('/details')">
                      <div class="action-icon">
                          <el-icon><User /></el-icon>
                      </div>
                      <div class="action-name">{{ t('my.accountDetails') }}</div>
                      <div class="action-arrow">→</div>
                  </div>
              </div>
          </div>


          <div class="payment-methods">
              <div class="methods-header"><span class="methods-title">{{ t('my.receivingAccount') }}</span>
                  <div class="methods-icon">💳</div>
              </div>
              <div class="methods-list">
                  <!-- <div class="method-item" @click="navigateTo('/bind-bank')">
                      <div class="method-icon bank-icon">🏦</div>
                      <div class="method-info">
                          <div class="method-name">{{ t('my.bankAccount') }}</div>
                          <div class="method-desc">{{ t('my.bankAccountDesc') }}</div>
                      </div>
                      <div class="method-status"><span class="status-text">{{ t('my.connect') }}</span><span class="arrow">›</span></div>
                  </div> -->
                  <div class="method-item" @click="navigateTo('/bind-usdt')">
                      <div class="method-icon crypto-icon">₿</div>
                      <div class="method-info">
                          <div class="method-name">{{ t('my.usdt') }}</div>
                          <div class="method-desc">{{ t('my.usdtDesc') }}</div>
                      </div>
                      <div class="method-status"><span class="status-text">{{ t('my.connect') }}</span><span class="arrow">›</span></div>
                  </div>
              </div>
          </div>


          <div class="settings-menu">
              <div class="menu-item" @click="navigateTo('/team')">
                  <div class="menu-icon">👥</div>
                  <div class="menu-content">
                      <div class="menu-title">{{ t('my.teamManagement') }}</div>
                      <div class="menu-subtitle">{{ t('my.viewTeam') }}</div>
                  </div>
                  <div class="menu-arrow">›</div>
              </div>
              <div class="menu-item" @click="navigateTo('/change-password')">
                  <div class="menu-icon">🔒</div>
                  <div class="menu-content">
                      <div class="menu-title">{{ t('my.changePassword') }}</div>
                      <div class="menu-subtitle">{{ t('my.passwordSettings') }}</div>
                  </div>
                  <div class="menu-arrow">›</div>
              </div>
              <div class="menu-item" @click="navigateTo('/change-withdraw-password')">
                  <div class="menu-icon">🔐</div>
                  <div class="menu-content">
                      <div class="menu-title">{{ t('my.changeWithdrawPassword') }}</div>
                      <div class="menu-subtitle">{{ t('my.passwordSettings') }}</div>
                  </div>
                  <div class="menu-arrow">›</div>
              </div>
  
              <div class="menu-item logout-item" @click="handleLogout">
                  <div class="menu-icon">🚪</div>
                  <div class="menu-content">
                      <div class="menu-title">{{ t('my.logout') }}</div>
                      <div class="menu-subtitle">{{ t('my.signOut') }}</div>
                  </div>
                  <div class="menu-arrow">›</div>
              </div>
          </div>


          <div class="bottom-logo">
              <div class="dynamic-logo">
                  <div class="logo-pulse"></div>
                  <div class="logo-core"><span class="logo-symbol">✨</span></div>
                  <div class="logo-rings">
                      <div class="ring ring-1"></div>
                      <div class="ring ring-2"></div>
                      <div class="ring ring-3"></div>
                  </div>
              </div>
              <div class="app-info"><span class="app-version">{{ t('my.version') }} 1.0</span></div>
          </div>
      </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { useTransition } from '@vueuse/core'
import { appConfig } from '@/config/app'
import { getUserInfo } from '@/api'
import { TOKEN_KEY } from '@/libs/util'
import '@/assets/css/my.css'

const router = useRouter()
const { t } = useI18n()

const userInfo = ref({
  username: '',
  tel: '',
  vip_level: '',
  invite_code: '',
  balance: 0,
  total_commission: 0,
  day_commission: 0,
  day_order_count: 0,
  order_num: 0
})

const inviteCode = computed(() => userInfo.value.invite_code)

const mainBalance = ref(0)
const todayCommission = ref(0)
const totalCommission = ref(0)

const animatedMainBalance = useTransition(mainBalance, {
  duration: 800,
  initialValue: 0
})

const animatedTodayCommission = useTransition(todayCommission, {
  duration: 800,
  initialValue: 0
})

const animatedTotalCommission = useTransition(totalCommission, {
  duration: 800,
  initialValue: 0
})

const displayMainBalance = computed(() => {
  const val = animatedMainBalance.value
  return Number.isFinite(val) ? val.toFixed(2) : '0.00'
})

const displayTodayCommission = computed(() => {
  const val = animatedTodayCommission.value
  return Number.isFinite(val) ? val.toFixed(2) : '0.00'
})

const displayTotalCommission = computed(() => {
  const val = animatedTotalCommission.value
  return Number.isFinite(val) ? val.toFixed(2) : '0.00'
})

const fetchUserInfo = async () => {
  try {
    const response = await getUserInfo()
    if (response.data.code === 200) {
      const data = response.data.data
      userInfo.value = {
        username: data.username,
        tel: data.tel,
        vip_level: data.vip_level,
        invite_code: data.invite_code,
        balance: data.balance,
        total_commission: data.total_commission,
        day_commission: data.day_commission,
        day_order_count: data.day_order_count,
        order_num: data.order_num
      }
      mainBalance.value = parseFloat(data.balance) || 0
      todayCommission.value = parseFloat(data.day_commission) || 0
      totalCommission.value = parseFloat(data.total_commission) || 0
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
  }
}

const copyInviteCode = async () => {
  try {
    await navigator.clipboard.writeText(inviteCode.value)
    ElMessage.success(t('my.copySuccess'))
  } catch (err) {
    ElMessage.error(t('my.copyFailed'))
  }
}

const navigateTo = (path) => {
  router.push(path)
}

const handleLogout = () => {
  localStorage.removeItem(TOKEN_KEY)
  sessionStorage.clear()
  router.push('/login')
}

const isFlipped = ref(false)
let flipInterval = null

const toggleFlip = () => {
  isFlipped.value = !isFlipped.value
}

onMounted(() => {
  fetchUserInfo()
  flipInterval = setInterval(toggleFlip, 3000)
})

onUnmounted(() => {
  if (flipInterval) {
    clearInterval(flipInterval)
  }
})
</script>

<style scoped>
.payment-methods{
    margin: 0 15px 16px;
    padding: 16px;
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow-card);
}
</style>
